import { render } from "./PesageStatique.vue?vue&type=template&id=39d9c0c0"
const script = {}

import "./PesageStatique.vue?vue&type=style&index=0&id=39d9c0c0&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__